import { ExperiencePerformanceTypes } from '@atlassian/ufo-experimental';
import { FMP_MARK, INLINE_RESPONSE_MARK } from '@atlassian/ufo-experimental/types';
import { isInitialPageLoad } from '../utils/is-initial-page-load';
import { navigationMetrics } from './plugins/navigation-metrics';
import { appTimings } from './plugins/timings/app';
import { bundleEvalTimings } from './plugins/timings/bundle-eval';
import { resourceTimings } from './plugins/timings/resource';
const LoadMetricKeys = {
  tti: 'metric:tti',
  fmp: 'metric:fmp',
  ttiHistograms: 'metric:tti:histogramBuckets',
  fmpHistograms: 'metric:fmp:histogramBuckets'
};
const InlineResultMetricKeys = {
  result: 'metric:result',
  response: 'metric:response',
  resultHistograms: 'metric:result:histogramBuckets',
  responseHistograms: 'metric:response:histogramBuckets'
};
const CustomMetricKeys = {
  duration: 'metric:duration',
  durationHistograms: 'metric:duration:histogramBuckets'
};
const getHistogram = (data, performanceConfig, isInitial) => {
  var _data$performanceConf;
  let histogram = {};
  if ((_data$performanceConf = data.performanceConfig) !== null && _data$performanceConf !== void 0 && _data$performanceConf.histogram) {
    histogram = data.performanceConfig.histogram;
  } else if (performanceConfig !== null && performanceConfig !== void 0 && performanceConfig.histogram) {
    histogram = performanceConfig.histogram;
  }
  if (histogram) {
    const histograms = histogram[data.performanceType];
    switch (data.performanceType) {
      case ExperiencePerformanceTypes.PageLoad:
      case ExperiencePerformanceTypes.PageSegmentLoad:
        const histogramType = isInitial !== undefined && isInitial === true ? 'initial' : 'transition';
        return histograms ? {
          [LoadMetricKeys.ttiHistograms]: histograms[histogramType].tti,
          [LoadMetricKeys.fmpHistograms]: histograms[histogramType].fmp
        } : {};
      case ExperiencePerformanceTypes.InlineResult:
        return histograms ? {
          [InlineResultMetricKeys.resultHistograms]: histograms.result,
          [InlineResultMetricKeys.responseHistograms]: histograms.response
        } : {};
      case ExperiencePerformanceTypes.Custom:
        return histograms ? {
          [CustomMetricKeys.durationHistograms]: histograms.duration
        } : {};
    }
  }
};
export const getLoadMetrics = (data, ssr, performanceConfig) => {
  var _data$metrics$marks$f;
  if (data.metrics.endTime === null || data.metrics.startTime === null) {
    return null;
  }
  const fmpMark = ((_data$metrics$marks$f = data.metrics.marks.find(mark => mark.name === FMP_MARK)) === null || _data$metrics$marks$f === void 0 ? void 0 : _data$metrics$marks$f.time) || isInitialPageLoad(data) && (ssr === null || ssr === void 0 ? void 0 : ssr.getDoneMark());
  const tti = data.metrics.endTime - data.metrics.startTime;
  const fmp = typeof fmpMark === 'number' ? fmpMark - data.metrics.startTime : tti;
  return {
    [LoadMetricKeys.tti]: Math.round(tti),
    [LoadMetricKeys.fmp]: Math.round(fmp),
    ...getHistogram(data, performanceConfig)
  };
};
export const getInlineResultMetrics = (data, performanceConfig) => {
  if (data.metrics.endTime === null || data.metrics.startTime === null) {
    return null;
  }
  const responseMark = data.metrics.marks.find(mark => mark.name === INLINE_RESPONSE_MARK);
  const result = data.metrics.endTime - data.metrics.startTime;
  const response = responseMark ? responseMark.time - data.metrics.startTime : result;
  return {
    [InlineResultMetricKeys.result]: Math.round(result),
    [InlineResultMetricKeys.response]: Math.round(response),
    ...getHistogram(data, performanceConfig)
  };
};
export const getCustomMetrics = (data, performanceConfig) => {
  if (data.metrics.endTime === null || data.metrics.startTime === null) {
    return null;
  }
  const duration = data.metrics.endTime - data.metrics.startTime;
  return {
    [CustomMetricKeys.duration]: Math.round(duration),
    ...getHistogram(data, performanceConfig)
  };
};
const getPerformanceMetrics = (data, ssr, performanceConfig) => {
  switch (data.performanceType) {
    case ExperiencePerformanceTypes.PageLoad:
    case ExperiencePerformanceTypes.PageSegmentLoad:
      return getLoadMetrics(data, ssr, performanceConfig);
    case ExperiencePerformanceTypes.InlineResult:
      return getInlineResultMetrics(data, performanceConfig);
    case ExperiencePerformanceTypes.Custom:
      return getCustomMetrics(data, performanceConfig);
  }
};
export const getPerformancePayload = (data, ssr, bundleEvalConfig, resourceConfig, performanceConfig) => {
  return {
    ...getPerformanceMetrics(data, ssr, performanceConfig),
    ...resourceTimings(data, resourceConfig),
    ...bundleEvalTimings(data, bundleEvalConfig),
    ...appTimings(data, ssr),
    ...(isInitialPageLoad(data) ? navigationMetrics() : null)
  };
};